module.exports = __webpack_public_path__ + "img/stigler_right.a74d44b3.png";